import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'src/environments/environment';
import { ExampleComponent } from './features/example/example/example.component';
import { ManualPDFAComponent } from './features/example/manual-pdf-a/manual-pdf-a.component';
import { PaymentBillComponent } from './features/payment/payment-bill/payment-bill.component';
import { PaymentBillFeeComponent } from './features/payment/payment-bill-fee/payment-bill-fee.component';
import { WebViewTermOfUseComponent } from './features/term-of-use/term-of-use.component';
import { WebViewNotificationsComponent } from './features/web-view-notifications/web-view-notifications.component';
import { CachingPrefixesInterceptor } from './core/http/caching-prefixs.interceptor';
import { ThaidCallbackComponent } from './features/thaid-callback/thaid-callback.component';
import { ManualComponent } from './features/manual/manual/manual.component';
import { LinkManualComponent } from './features/link-manual/link-manual.component';
//import { environment } from 'src/environments/environment.demo';
//import { environment } from 'src/environments/environment.demo';



export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    ExampleComponent,
    ManualPDFAComponent,
    PaymentBillComponent,
    PaymentBillFeeComponent,
    WebViewTermOfUseComponent,
    WebViewNotificationsComponent,
    ThaidCallbackComponent,
    ManualComponent,
    LinkManualComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    ReactiveFormsModule,
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    CoreModule,
    HttpClientModule,
    FormsModule,
    NgbModule,
    // SharedFeatureModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    NgxPermissionsModule.forRoot(),

  ],
  providers: [
    { provide: APP_BASE_HREF, useValue: environment.baseHref }, 
    { provide: HTTP_INTERCEPTORS, useClass: CachingPrefixesInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
